import { render, staticRenderFns } from "./MapCell.vue?vue&type=template&id=2d8c4210&scoped=true&"
import script from "./MapCell.vue?vue&type=script&lang=js&"
export * from "./MapCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c4210",
  null
  
)

export default component.exports